"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalSS = void 0;
var legalSSshort_cms_1 = require("./legalSSshort.cms");
var LegalSS = /** @class */ (function () {
    function LegalSS() {
        this.legalModalPath = [
            '/idpassets/fragment/legal/prod/legalmodal/offers/wireline/checkout/standardshippinglm.cmsfeed.js',
        ];
        this.legalShortPath = new legalSSshort_cms_1.LegalSSShort();
    }
    return LegalSS;
}());
exports.LegalSS = LegalSS;
//# sourceMappingURL=legalSS.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoWLS/legalSS.cms.js
// module id = 1993
// module chunks = 8